import { Navigate, useLocation } from 'react-router-dom';
import useAuthStore from '../../store/authStore';

// Set to true during development to bypass auth
const DEV_MODE = false; // Disabled for proper testing

export default function ProtectedRoute({ children, allowedRoles = null }) {
  const { isAuthenticated, role } = useAuthStore();
  const location = useLocation();

  // Allow access in development mode
  if (DEV_MODE) {
    return children;
  }

  // Not authenticated - redirect to appropriate login
  if (!isAuthenticated) {
    // If trying to access student routes, redirect to student login
    if (location.pathname.startsWith('/app')) {
      return <Navigate to="/student-login" state={{ from: location }} replace />;
    }
    // Otherwise redirect to teacher login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If specific roles are required, check them
  if (allowedRoles && !allowedRoles.includes(role)) {
    // Redirect to appropriate dashboard based on actual role
    if (role === 'teacher') {
      return <Navigate to="/teacher" replace />;
    } else if (role === 'student') {
      return <Navigate to="/app" replace />;
    }
    // Fallback to home
    return <Navigate to="/" replace />;
  }

  return children;
}

// Convenience component for teacher-only routes
export function TeacherRoute({ children }) {
  return (
    <ProtectedRoute allowedRoles={['teacher']}>
      {children}
    </ProtectedRoute>
  );
}

// Convenience component for student-only routes
export function StudentRoute({ children }) {
  return (
    <ProtectedRoute allowedRoles={['student']}>
      {children}
    </ProtectedRoute>
  );
}
